import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import axios from "axios";
import "../CSS/GalleryEdit4.css";

const GalleryEdit4=()=>{

    const images = [
        { id: 1, src: "https://i.ibb.co/sm8mdMP/pic16.jpg", alt: "" },
        { id: 2, src: "https://i.ibb.co/Gnq2gJb/pic2.jpg", alt: "" },
        { id: 3, src: "https://i.ibb.co/vDpCDSY/pic13.jpg", alt: "" },
        { id: 4, src: "https://i.ibb.co/f0Yt9bM/pic4.jpg", alt: "" },
        { id: 5, src: "https://i.ibb.co/g4hxBfz/pic5.jpg", alt: "" },
        { id: 6, src: "https://i.ibb.co/FgdgX20/pic10.jpg", alt: "" },
        { id: 7, src: "https://i.ibb.co/kDjJwhB/pic7.jpg", alt: "" },
        { id: 8, src: "https://i.ibb.co/9n7mHQt/pic8.jpg", alt: "" },
      ];

      const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    fetchGalleryData();
  }, []);

  const fetchGalleryData = async () => {
    try {
      const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getGalleryContent1");
      const data = response.data ? Object.values(response.data) : [];
      setGalleryData(data);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    }
  };
  
    return(
        <div className="gallery-edit4">
         {galleryData.length > 0 && galleryData.map((gallery, index) => (
            <div key={index}>
                <h1 className="text-center">{gallery.title4}</h1>
                <p>{gallery.description4}</p>
            </div>
         ))}
        <div className="galleryedit4">
        {galleryData[0]?.subtitles4?.map((data) => (
          <span key={data.subtitle_id} style={{ "--i": data.subtitle_id }} className="Galleryedit4span">
            <img src={data.subimage} alt={data.subtitle} />
          </span>
        ))}
      </div>
      </div>
    );
}

export default GalleryEdit4;